import { Application } from '@typeRoots/common/application';
import { Loss } from '@typeRoots/common/loss';

export const initialApplicationState: Application = {
  applicationStep: 'LOB',
  //auto liability
  autoLiabilityRequested: true, //section = Auto Liability
  autoLiabilityLimitRequested: {
    //section=Auto Liability, sub=Auto Liability Limit
    amount: 1000000,
    currency: 'USD',
  },
  personalInjuryProtectionRequested: false, //section= Auto Liability, sub= Personal Injury Protection
  uninsuredMotoristRequested: false, //section= Auto Liability, sub= Uninsured Motorist

  //physical damage
  automobilePhysicalDamageRequested: true, //section = Physical Damage
  deductible: {
    //setion=physical damage, sub= Deductible
    amount: 1000,
    currency: 'USD',
  },

  trailerInterchangeRequested: false, //section=physical damage, sub= Trailer Interchange Limit
  trailerInterchangeLimitRequested: {
    //section=physical damage, sub= Trailer Interchange Limit
    amount: 0,
    currency: 'USD',
  },
  uiiaIntermodal: false, //if trailerInterchangeLimitRequested = 30000 set this true other wise false

  includeAPDTowing: false, //section=physical damage, sub= Towing Labor and Storage
  towingStorageLimitRequested: {
    //section=physical damage, sub= Towing Labor and Storage
    amount: 10000,
    currency: 'USD',
  },

  //Motor truck cargo
  motorTruckCargoRequested: true, //insurance = Motor Truck Cargo
  motorTruckCargoLimitRequested: {
    //section = Motor Truck Cargo
    amount: 100000,
    currency: 'USD',
  },
  motorTruckDeductibleRequested: {
    //setion=Motor truck cargo, sub= Deductible
    amount: 1000,
    currency: 'USD',
  },

  //General Liability
  truckingGeneralInsuranceRequested: true,
  truckingGeneralInsuranceLimitRequested: {
    amount: 1000000,
    currency: 'USD',
  },

  //Non-Trucking Liability
  nonTruckingLiabilityRequested: false,

  //// POLICY QUESTIONS \\\
  ownerName: '',
  ownerDob: null,
  operations: [],
  federalAutoLiabilityFilingRequested: false, //policy questions
  stateAutoLiabilityFilingRequested: false, //policyquestions
  additionalInsured: {
    name: '',
    address: {
      street: '',
      city: '',
      state: 'NY',
      zipCode: '',
      county: '',
      latitude: 0,
      longitude: 0,
    },
  },
  effectiveDateRequested: new Date(),

  //static values
  insuredWaiverSubrogation: false,
  blanketAdditionalInsured: false,
  hiredNonOwnedAuto: false,
  nonOwnedTrailer: false,
  primaryNoncontributoryTruckingGeneralLiabilityRequested: false,
  primaryNoncontributoryAutoLiabilityRequested: false,

  priorInsuranceCancelled: false, //ask for default value
  bankruptciesLastFiveYears: false, //ask for default value
  peronsalUseOfVehicle: false, //ask for default value
  eldDataSharingOption: 'eld_only', //ask for default value
  eldVendor: '', //ELD provider - wired to backend
  deductibleType: 'Custom', //ask for default value

  //only this will be changes based on number of vehicles
  annualMileage: 1000, //ask for default value

  //company
  company: {
    id: 1,
  },
};

export const initialLossState: Loss = {
  lossYear: 0,
  lossConfirmed: false,
  lossCountAutoLiability: 0,
  lossPaidAutoLiability: { amount: 0, currency: 'USD' },
  lossCountAutoPhysicalDamage: 0,
  lossPaidAutoPhysicalDamage: { amount: 0, currency: 'USD' },
  lossCountMotorTruckCargo: 0,
  lossPaidMotorTruckCargo: { amount: 0, currency: 'USD' },
  lossCountTruckingGeneralLiability: 0,
  lossPaidTruckingGeneralLiability: { amount: 0, currency: 'USD' },
  lossCountNonTruckingLiability: 0,
  lossPaidNonTruckingLiability: { amount: 0, currency: 'USD' },
  company: { id: 1 },
};
